var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-menu',{attrs:{"background-color":"#e5e6e6","text-color":"#99c5d3","active-text-color":"#251706","router":""}},[_c('el-menu-item',{key:"ActivityList",attrs:{"index":"/ActivityList"}},[_vm._v(" Activity列表 ")]),_c('el-menu-item',{key:"PythonList",attrs:{"index":"/PythonList"}},[_vm._v(" Python列表 ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }